import { createEntityAdapter } from '@reduxjs/toolkit';
import { FarmStatus } from 'data/farm-status';

const farmStatusAdapter = createEntityAdapter<FarmStatus>({
  selectId: (farmStatus) => farmStatus.farmId,
});

export default farmStatusAdapter;
